type ENV = "dev" | "prod" | "demo";

export const currentEnv: string = "prod";

const env: string = currentEnv;

export const Env = env;

const API_DEV_URL = "https://api.dev.easymarket.sn";
const API_DEMO_URL = "https://api.recette.dev.easymarket.sn";
const API_PROD_URL = "https://api.easymarket.sn";

const VENDEUR_APIKEY_DEMO =
  "5528ba702684a737259ab6d41ab3fe5f8d2324fecd49e3f3e31c38ac0f24d475";
const VENDEUR_APIKEY_PROD =
  "5528ba702684a737259ab6d41ab3fe5f8d2324fecd49e3f3e31c38ac0f24d475";

export const APP_URL_DEV = "https://dev.web.easymarket.sn/";
export const APP_URL_DEMO = "https://kazamansa.com";
export const APP_URL_PROD = "https://kazamansa.com";

function processApiUrl() {
  if (env === "prod") return API_PROD_URL;
  if (env === "demo") return API_DEMO_URL;
  return API_DEV_URL;
}

function processAppUrl() {
  if (env === "prod") return APP_URL_PROD;
  if (env === "demo") return APP_URL_DEMO;
  return APP_URL_DEV;
}

function processApikey() {
  if (env === "prod") return VENDEUR_APIKEY_PROD;
  if (env === "demo") return VENDEUR_APIKEY_DEMO;
  return VENDEUR_APIKEY_DEMO;
}

export const ApiBaseUrl = processApiUrl();
export const AppBaseUrl = processAppUrl();

export const VendeurApikey = processApikey();

export const GoogleApikey = "AIzaSyChXWZKmUgaWFvIV2WnTVoR2lY3-uhReBg";

export const IntechApikey = "";

export const GoogleClientId =
  "701177325323-33rje48k1alj39qmb9vspat9urmmrojn.apps.googleusercontent.com";
